export default [
  { label: 'Fusebill v001', value: 'SignatureTemplateFusebill001' }
]
